export default "__VITE_ASSET__Bp0NGFU9__"